import { Pipe, PipeTransform } from '@angular/core';

import { getSearchResultState } from './search.functions';

@Pipe({
  name: 'searchResultState'
})
export class SearchResultStatePipe implements PipeTransform {
    transform(result: any): string {
        return getSearchResultState(result);
    }
};